import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { LsbApi, type PostRequestRequest, type PostRequestResponse } from '@shared/api';

const postRequestEffect = createEffect((request: PostRequestRequest) => LsbApi.postRequest(request));
const clearEvent = createEvent();

const $dataStore = createStore<PostRequestResponse | null>(null)
  .on(postRequestEffect.done, (_, data) => data.result.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(postRequestEffect.pending, (_, data) => data)
  .on(postRequestEffect.fail, () => false)
  .on(postRequestEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(postRequestEffect, () => null)
  .on(
    postRequestEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while sending Request. Please try again.').message,
  )
  .on(postRequestEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $postRequestStore = {
  events: {
    postRequest: postRequestEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
